import * as models from 'models/index';
import { media } from 'util/style-variables';
import { StyleSheet } from 'aphrodite/no-important';

export const style: any = (styles: models.base.IGenericObject) => StyleSheet.create({
  grid: {
    padding: '10px 0',
    width: '100%',
    ...styles.gridStyles.general,

    [media.tablet]: {
      ...styles.gridStyles.general.tablet,
    },

    [media.desktop]: {
      ...styles.gridStyles.general.desktop,
    }
  },

  text_wrapper: {
    marginBottom: 20,

    [media.tablet]: {
      marginBottom: 40,
    }
  },

  headline: {
    paddingBottom: '0px',
    lineHeight: 1.2,
    marginBottom: 3,
    ...styles.globalStyles.headlines,
    ...styles.gridStyles.headline,

    [media.tablet]: {
      ...styles.globalStyles.headlines.tablet,
      ...styles.gridStyles.headline.tablet
    },

    [media.desktop]: {
      ...styles.globalStyles.headlines.desktop,
      ...styles.gridStyles.headline.desktop
    }
  },

  subheadline_wrapper: {
    display: 'flex',
    flexDirection: 'column',

    [media.tablet]: {
      flexDirection: 'row'
    }
  },

  description: {
    flexGrow: 1,
    ...styles.gridStyles.description,

    [media.tablet]: {
      marginBottom: 15,
      ...styles.gridStyles.description.tablet
    },

    [media.desktop]: {
      ...styles.gridStyles.description.desktop
    }
  },

  additional_info: {
    fontSize: '14px',
    padding: '10px 0 0',
    ...styles.gridStyles.additionalInfo,

    [media.tablet]: {
      fontSize: '16px',
      ...styles.gridStyles.additionalInfo.tablet
    },

    [media.desktop]: {
      ...styles.gridStyles.additionalInfo.desktop
    }
  },

  count: {
    ...styles.gridStyles.voteCountNumber,

    [media.tablet]: {
      ...styles.gridStyles.voteCountNumber.tablet
    },

    [media.desktop]: {
      ...styles.gridStyles.voteCountNumber.desktop
    }
  },

  countLabel: {
    padding: 0,
    ...styles.gridStyles.voteCountLabel,

    [media.tablet]: {
      textAlign: 'right',
      ...styles.gridStyles.voteCountLabel.tablet
    },

    [media.desktop]: {
      ...styles.gridStyles.voteCountLabel.desktop
    }
  },

  panel_window: {
    display: 'grid',
    width: '100%',
    gridGap: 20,
    marginBottom: 20,
    gridTemplateColumns: `repeat(${styles.columns.mobile}, 1fr)`,
    [media.tablet]: {
      gridTemplateColumns: `repeat(${styles.columns.tablet}, 1fr)` 
    },

    [media.desktop]: {
      gridTemplateColumns: `repeat(${styles.columns.desktop}, 1fr)` 
    }
  },

  sort_wrapper: {
    paddingTop: '10px',

    [media.tablet]: {
      paddingTop: '0'
    }
  },

  sort_button_inactive: {
    backgroundColor: 'transparent',
    display: 'inline-block',
    color: '#999',
    cursor: 'pointer',
    fontSize: '16px'
  },

  sort_button_active: {
    backgroundColor: 'transparent',
    display: 'inline-block',
    pointerEvents: 'none',
    cursor: 'default',
    color: '#000',
    fontSize: '16px'
  },

  sort_label: {
    color: '#999',
    fontSize: '16px'
  },

  video: {
    margin: '0 auto 40px',
    maxWidth: 700
  }
});
